import { createRoute } from '@tanstack/react-router';
import { IconAlertTriangle, IconTruck } from '@tabler/icons-react';
import type { Zone } from '@hana/shell';
import { MovHome } from './MovHome';
import { Incidents } from './Incidents';
import { Photos } from './Photos';
import { Profile } from './Profile';
import { Vehicle } from './Vehicle';
import { News } from './News';
import { Nav } from './Nav';
import { TripDetail } from './TripDetail';
import { CostScreen } from './Cost';
import { MovLayout } from './MovTabs';

// Vùng HANA Mov (/mov): app tài xế (luồng F, docs/streams/F.md). Màn Chuyến của tôi: MovHome (F-07a).

export const zone: Zone = {
  key: 'mov',
  name: 'HANA Mov',
  top: [{ key: 'home', label: 'Chuyến', to: '/mov', icon: IconTruck }, { key: 'incident', label: 'Báo sự cố', to: '/mov/incident', icon: IconAlertTriangle }],
  nav: [],
  routes: (parent) => {
    const layout = createRoute({ getParentRoute: () => parent, id: 'mov-tabs', component: MovLayout });
    return [layout.addChildren([
    createRoute({ getParentRoute: () => layout, path: '/', component: MovHome }),
    createRoute({ getParentRoute: () => layout, path: '/incident', component: Incidents }),
    createRoute({ getParentRoute: () => layout, path: '/photo', component: Photos }),
    createRoute({ getParentRoute: () => layout, path: '/me', component: Profile }),
    createRoute({ getParentRoute: () => layout, path: '/vehicle', component: Vehicle }),
    createRoute({ getParentRoute: () => layout, path: '/news', component: News }),
    createRoute({ getParentRoute: () => layout, path: '/nav', component: Nav }),
    createRoute({ getParentRoute: () => layout, path: '/trip', component: TripDetail }),
    createRoute({ getParentRoute: () => layout, path: '/cost', component: CostScreen }),
  ])];
  },
};
